module.exports = __webpack_public_path__ + "static/media/Farelogix.eb0f4aa1.svg";